module.exports = __webpack_public_path__ + "static/media/YB5M03_5.7509a436.jpg";